const {
  AffirmBanner,
  ArticleEmbed,
  ArticleGridEmbed,
  BrandCalloutEmbed,
  CSPMiniGridEmbed,
  CalloutEmbed,
  CategoryCalloutEmbed,
  CategoryNestedNav,
  ComparisonShoppingPageCardManager,
  FollowButtonContainer,
  HandpickedCalloutEmbed,
  HomepageCuratedSetRow,
  HomepageFeed,
  LPAlbumRowEmbed,
  ListingRow,
  LogoSwitcherContainer,
  MobileDetection,
  Modal,
  NewsNav,
  OfferButton,
  RegionalListings,
  SimilarCSPsRow,
  SiteSearch,
  Stars,
  StarsWithCount,
  Translations,
  VideoEmbed,
  alt,
  buildReverbRouter,
  buildRootRoutes,
  SellCSPPreview,
  trackTimings,
} = require('@reverbdotcom/discovery-ui');

window.I18n.translations.en.discovery = Translations;
window.I18n.translations.en.cms = require('@reverbdotcom/commons').CMSTranslations;

window.Reverb.AffirmBanner = AffirmBanner;
window.Reverb.ArticleEmbed = ArticleEmbed;
window.Reverb.ArticleGridEmbed = ArticleGridEmbed;
window.Reverb.BrandCalloutEmbed = BrandCalloutEmbed;
window.Reverb.CalloutEmbed = CalloutEmbed;
window.Reverb.CategoryCalloutEmbed = CategoryCalloutEmbed;
window.Reverb.LPAlbumRowEmbed = LPAlbumRowEmbed;
window.Reverb.CategoryNestedNav = CategoryNestedNav;
window.Reverb.ComparisonShoppingPageCardManager = ComparisonShoppingPageCardManager;
window.Reverb.CSPMiniGridEmbed = CSPMiniGridEmbed;
window.Reverb.FollowButtonContainer = FollowButtonContainer;
window.Reverb.HandpickedCalloutEmbed = HandpickedCalloutEmbed;
window.Reverb.HomepageCuratedSetRow = HomepageCuratedSetRow;
window.Reverb.HomepageFeed = HomepageFeed;
window.Reverb.ListingRow = ListingRow;
window.Reverb.LogoSwitcherContainer = LogoSwitcherContainer;
window.Reverb.Modal = Modal;
window.Reverb.NewsNav = NewsNav;
window.Reverb.RegionalListings = RegionalListings;
window.Reverb.SimilarCSPsRow = SimilarCSPsRow;
window.Reverb.SearchBarV2 = SiteSearch;
window.Reverb.Stars = Stars;
window.Reverb.StarsWithCount = StarsWithCount;
window.Reverb.VideoEmbed = VideoEmbed;
window.Reverb.OfferButton = OfferButton;
window.Reverb.SellCSPPreview = SellCSPPreview;

window.Reverb.CommonAlt = alt;

trackTimings();
const Routes = require('./shared/routes.jsx');

window.Reverb.Routes = buildRootRoutes(Routes); // exposed for server side rendering

const trackPageView = require('./track_page_view.js');

window.Reverb.noRouterContext = true;
window.Reverb.Router = buildReverbRouter(Routes, {
  onUpdate: () => {
    trackPageView(window.location);
    window.Reverb.noRouterContext = false;
  },
});

window.Reverb.MobileDetection = MobileDetection;



// WEBPACK FOOTER //
// ./javascripts/components/discovery.js